export const defaultCheckExceptionModelDto = {
    arpExceptionDetailUniqueId: '',
    arpExceptionDetailId: 0,
    paidAmount: 0,
    companyId: 0,
    isCorrectionRequestCreated: false,
    accountNumber: '-',
};
